export default __webpack_public_path__ + "static/media/warehouse.02af0fa8.jpg";